module.exports = __webpack_public_path__ + "static/img/service (2).f71f0a61.jpg";